import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type useActivityCriteria_query$data,
  type useActivityCriteria_query$key
} from '@/__generated__/useActivityCriteria_query.graphql'
import { type useActivityCriteriaMutation } from '@/__generated__/useActivityCriteriaMutation.graphql'

type CommitAsyncFn = (activityIds: string[]) => Promise<useActivityCriteria_query$data>

export const useActivityCriteria = (
  queryRef?: useActivityCriteria_query$key | null | undefined
): [string[], CommitAsyncFn, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment useActivityCriteria_query on Query {
        currentUser {
          activityCriteria(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {
            nodes {
              activityId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.activityCriteria.nodes, 'activityId'),
    [queryData?.currentUser?.activityCriteria.nodes]
  )
  const [commit, isPending] = useMutation<useActivityCriteriaMutation>(graphql`
    mutation useActivityCriteriaMutation($input: UpdateActivityCriteriaInput!) {
      updateActivityCriteria(input: $input) {
        query {
          ...useActivityCriteria_query
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (activityIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              activityIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
